import React from "react";


const TagSchemeCellRenderer = (props:any)=>{
    //console.log(props);
    const onClickLink = ()=>{
        //console.log(props);
        props.editAction("editTruck", props.data);
    }
    return(
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickLink} className={"cellRender"}>{props && props.value}</span></a>
        </div>

    )
}

export default TagSchemeCellRenderer;
